interface IProps {
  rollBlock: number;
  currentBlock: number;
}

const DBetGameBlockStats: React.FC<IProps> = ({
  rollBlock,
  currentBlock
}: IProps) => (
  <>
    <div className="prizeWrapper">
      <div className="prizeText">ROLL BLOCK</div>
      <div className="prizeValue">{`#${rollBlock}`}</div>
    </div>
    <div className="prizeWrapper">
      <div className="prizeText">BLOCKS LEFT</div>
      <div className="prizeValue">{`#${rollBlock - currentBlock}`}</div>
    </div>
    <div className="prizeWrapper">
      <div className="prizeText">CURRENT BLOCK</div>
      <div className="prizeValue">{`#${currentBlock}`}</div>
    </div>
  </>
);

export default DBetGameBlockStats;
